export default __webpack_public_path__ + "images/inventry-icon-ad.svg";